import { render, staticRenderFns } from "./ConfirmRemovePopup.vue?vue&type=template&id=40521f07"
import script from "./ConfirmRemovePopup.vue?vue&type=script&lang=js"
export * from "./ConfirmRemovePopup.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRemovePopup.vue?vue&type=style&index=0&id=40521f07&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports